module.exports = __webpack_public_path__ + "static/media/KP_05.931fd889.jpg";